module.exports = __webpack_public_path__ + "img/CHECK-Mark.34c990b1.svg";